export const DIGITAL_STATUS = {
  SIG: 'SIG',
} as const
